import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { showCurrency } from '../../../../MyApi/sb/currency';

import PageHeader from '../../../../Components/UI/PageHeader';
import CurrencyDetalis from '../../../../Components/sb/currency/currencyShow/currencyDetalis';
import LoadingSpinner from '../../../../Components/UI/spinner';



const CurrencyShow = () => {
  const {id} = useParams()

const {i18n}=useTranslation()
const lang = i18n.language
  const { data , isLoading, error, isFetching } = useQuery(
    ["showCurrency", id,lang],
    ()=>showCurrency(id,lang) 
  );

  const showCurriences = data?.data;

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data && !isFetching) {
    return <div>no data available</div>;
  }
  if (error) {
    return <div>error</div>;
  }


  return (
    <div>
      <PageHeader title="تفاصيل العملة"  showBack={true}/>
      <CurrencyDetalis showCurriences={showCurriences} />
    </div>
  )
}

export default CurrencyShow